function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-3.49691e-07 8C-3.25549e-07 8.5523 0.44772 9 1 9L8.1575 9L4.91501 12.2425L6.3292 13.6567L11.9861 7.9999L6.3292 2.343L4.91501 3.7572L8.1578 7L1 7C0.44772 7 -3.73833e-07 7.4477 -3.49691e-07 8ZM10 14L10 16L14 16C15.1046 16 16 15.1046 16 14L16 2C16 0.895399 15.1046 -6.60243e-07 14 -6.11959e-07L10 -4.37114e-07L10 2L14 2L14 14L10 14Z",
  fill: "white",
  className: "svg-fill"
});

var SvgSignInAlt = function SvgSignInAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignInAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-in-alt.6c2eed0f.svg";
export { ForwardRef as ReactComponent };